import React, { useEffect, useState } from 'react';
import { InputGroup, InputGroupText, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export default function AdressInfo({ title, setTitle, companyNameFirma1, setCompanyNameFirma1, kontaktName1, setKontaktName1, plz1, setPLZ1, streetAndNr1, setStreetAndNr1, adresszusatz1, setAdresszusatz1, länderkürzel1, setLänderkürzel1, state1, setState1, city1, setCity1, tel1, setTel1, shipperNumber, setShipperNumber, packageReferenceNumberValue, setPackageReferenceNumberValue }) {
   // const [name, setName] = useState('ZA GmbH');
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(!open);

    const [shipmentNameAndInfo, setShipmentNameAndInfo] = useState([])
    const getShipmentNameAndInfo = async () => {
        try {
            const response = await fetch(`/shipment/company/addresses`, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
            });
            const payload = await response.json();
            setShipmentNameAndInfo(payload)
            console.log(payload)
            if (response.ok) {
            }
            if (!response.ok) {
                const payload = await response.json();
                alert(payload)
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getShipmentNameAndInfo();
    }, [])

    const handleShipmentNameAndInfoChange = (company) => {
        setTitle(company.Title)
        setCompanyNameFirma1(company.Name)
        setKontaktName1(company.AttentionName)
        setPLZ1(company.PostalCode)
        setStreetAndNr1(company.AddressLine1)
        setAdresszusatz1(company.AddressLine2)
        setLänderkürzel1(company.CountryCode)
        setState1(company.StateProvinceCode)
        setCity1(company.City)
        setTel1(company.Phone)
        setShipperNumber(company.shipperNumber)
        setPackageReferenceNumberValue(company.packageReferenceNumberValue)
    }
    return (
        <div className="mr-5">
                            <InputGroup className="mr-2">
                   {/** <InputGroupText>
                        Title:
                    </InputGroupText>
 */}
                    <Dropdown isOpen={open} toggle={toggle}>
                        <DropdownToggle caret >
                            <b style={{fontSize: 'larger', letterSpacing: '0.5px'}}>{title ? title : 'Bitte auswählen'}</b>
                        </DropdownToggle>
                        <DropdownMenu>
                            {shipmentNameAndInfo.map((company, index) => {
                                return (
                                    <DropdownItem key={index} onClick={() => { handleShipmentNameAndInfoChange(company) }}>{company.Title}</DropdownItem>
                                )
                            })}
                        </DropdownMenu>
                    </Dropdown>
                </InputGroup>
            <div className="d-flex justify-content-between mb-2 mt-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                    Name/Firma:
                    </InputGroupText>
                    <Input
                        disabled
                        value={companyNameFirma1}
                    />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Kontaktname:
                    </InputGroupText>
                    <Input
                        disabled
                        value={kontaktName1}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        PLZ:
                    </InputGroupText>
                    <Input 
                    //style={{maxWidth: '100px'}}
                        disabled
                        value={plz1}
                    />
                </InputGroup>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Straße + Nr.:
                    </InputGroupText>
                    <Input
                        disabled
                        value={streetAndNr1}
                    />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Adresszusatz:
                    </InputGroupText>
                    <Input
                        disabled
                        value={adresszusatz1}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        Länderkürzel:
                    </InputGroupText>
                    <Input
                        disabled
                        value={länderkürzel1}
                    />
                </InputGroup>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <InputGroup className="mr-5">
                    <InputGroupText>
                        State:
                    </InputGroupText>
                    <Input
                        disabled
                        value={state1}
                    />
                </InputGroup>
                <InputGroup className="mr-5">
                    <InputGroupText>
                        Stadt:
                    </InputGroupText>
                    <Input
                        disabled
                        value={city1}
                    />
                </InputGroup>
                <InputGroup className="">
                    <InputGroupText>
                        Telefon:
                    </InputGroupText>
                    <Input
                        disabled
                        value={tel1}
                    />
                </InputGroup>
            </div>
        </div>
    );
}
